import { type Block, contentText, normalizeTiptap, type TiptapDoc, tiptapToBlocks } from "@klarity/schema";

export function toBlocks(content: TiptapDoc): Block[] {
  try {
    return tiptapToBlocks(content);
  } catch {
    return tiptapToBlocks(normalizeTiptap(content));
  }
}

const LABELS: Record<Block["type"], string> = {
  h1: "Heading 1",
  h2: "Heading 2",
  p: "Paragraph",
  kv: "Key–value",
  bullets: "Bullets",
  steps: "Steps",
  table: "Table",
  groupTable: "Group list",
  code: "Code",
  note: "Note",
  warning: "Warning",
  pageBreak: "Page break",
  image: "Image",
};

export function blockLabel(b: Block): string {
  return LABELS[b.type];
}

export function blockSummary(b: Block): string {
  if (b.type === "pageBreak") return "Page break";
  const text = contentText([b]).replace(/\s+/g, " ").trim();
  if (!text) return b.type === "image" ? "Image" : "(empty)";
  return text.length > 160 ? `${text.slice(0, 159)}…` : text;
}
